/** Native wrapped SOL mint (Raydium / Jupiter convention). */
export const SOL_MINT = "So11111111111111111111111111111111111111112";

/** Mainnet SPL USDC mint (common Jupiter quote asset). */
export const USDC_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
